import { jwtDecode } from "jwt-decode";
import cookie from "./cookie.js";
import { getUserRole, getUserOrg } from "../api/index.js";

const jwt = {
	getToken: () => cookie.get("_mycookie"),
	setToken: (token) => token && cookie.set("_mycookie", token),
	destroyToken: () => {
		cookie.remove("_mycookie");
	},
	isAuthenticated: () => {
		const token = cookie.get("_mycookie");
		return token && token !== "undefined";
	},
	isAdmin: async () => {
		const { success: successCode, role } = await getUserRole();
		console.log(successCode && role === "admin")
		if (successCode && role === "ADMIN") {
			return true;
		}
		return false;
	},
	isKentroUser: async () => {
		const { success: successCode, role } = await getUserRole();
		return successCode && role === "KENTRO_USER";
	},
	getUserOrg: async () => {
		const { success: successCode, orgId } = await getUserOrg();
		if (successCode && orgId) {
			return orgId;
		}
		return null;
	},
	decode: () => {
		const token = cookie.get("_mycookie");
		if (token) return jwtDecode(token);
		cookie.remove("_mycookie");
		window.location.href = "/";
		return null;
	},
};

export default jwt;
